import httpRequest from '../../utils/httpRequest'

export const SET_ACCOUNT = 'account/SET_ACCOUNT'
export const SET_USER_INFO = 'account/SET_USER_INFO'
export const SET_NEEDAUTH = 'account/SET_NEEDAUTH'

export const setAccount = data => dispatch =>
  dispatch({
    type: SET_ACCOUNT,
    data,
  })

export const setUserInfo = data => dispatch =>
  dispatch({
    type: SET_USER_INFO,
    data,
  })

export const setNeedAuth = data => dispatch =>
  dispatch({
    type: SET_NEEDAUTH,
    data,
  })

export const getAccount = address => async dispatch => {
  try {
    const userInfo = await httpRequest.getAccount(address)
    dispatch(setUserInfo(userInfo))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
